import React from 'react';
import I18n from 'helpers/I18n';

class Wizard extends React.Component {
  static propTypes = {
    className:  React.PropTypes.string,
    submitting: React.PropTypes.bool,
    onDone:     React.PropTypes.func.isRequired,
  }

  state = {
    currentPageIndex: 0,
    furthestPageIndex: 0,
    allDone: false,
  }

  previousPage = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.setState({ currentPageIndex: this.state.currentPageIndex - 1 });
  }

  pageDone = () => {
    if (this.isLastPage()) {
      this.setState({ allDone: true });
    } else {
      this.nextPage();
    }
  }

  nextPage = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (this.isLastPage()) {
      return;
    }
    this.setState({
      currentPageIndex: this.state.currentPageIndex + 1,
      furthestPageIndex: Math.max(this.state.furthestPageIndex, this.state.currentPageIndex + 1)
    });
  }

  progress() {
    return 100 * (this.state.currentPageIndex + 1) / (this.props.children.length);
  }

  isFirstPage() {
    return this.state.currentPageIndex === 0;
  }

  isLastPage() {
    return this.state.currentPageIndex === this.props.children.length - 1;
  }

  seenNextPage() {
    return this.state.currentPageIndex < this.state.furthestPageIndex;
  }

  renderNav() {
    const navButtons = [];
    if (!this.isFirstPage()) {
      navButtons.push(
        <a className="btn btn-default" key="back" href="javascript:;" onClick={this.previousPage}>{I18n.t("test_wizard.previous")}</a>
      );
    }
    if (this.seenNextPage()) {
      navButtons.push(
        <a className="btn btn-default" key="next" href="javascript:;" onClick={this.nextPage}>{I18n.t("test_wizard.next")}</a>
      );
    }

    const navBtnGroup = navButtons.length > 0 ? <div className="btn-group form-group">{navButtons}</div> : null;

    let submitButton;
    if (this.state.allDone) {
      submitButton = (
        <div className="pull-right">
          <button className="btn btn-primary" disabled={this.props.submitting} onClick={this.props.onDone}>{I18n.t("test_wizard.submit")}</button>
        </div>
      );
    }
    return (
      <div className="wizard-nav clearfix">
        {navBtnGroup}
        {submitButton}
      </div>
    );
  }

  render() {
    return (
      <div className={this.props.className}>
        <div className="wizard-pages">
          {this.props.children[this.state.currentPageIndex]}
        </div>
        <div className="progress">
          <div className="progress-bar progress-bar-striped"
              role="progressbar"
              aria-valuenow={this.progress()}
              aria-valuemin="0"
              aria-valuemax="100"
              style={ { width: `${this.progress().toString()}%` } }>
          </div>
        </div>
        {this.renderNav()}
      </div>
    );
  }
}

class WizardPage extends React.Component {
  render() {
    return (
      <div className="test-wizard-page">
        {this.props.children}
      </div>
    );
  }
}

Wizard.Page = WizardPage;
export default Wizard;



// WEBPACK FOOTER //
// ./app/javascript/components/application/Wizard.jsx